import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const audioFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'aac', value: 'aac'
    },
    {
        name: 'cda', value: 'cda'
    },
    {
        name: 'x-cdf', value: 'x-cdf'
    },
    {
        name: 'midi', value: 'midi'
    },
    {
        name: 'mid', value: 'mid'
    },
    {
        name: 'x-midi', value: 'x-midi'
    },
    {
        name: 'mp3', value: 'mp3'
    },
    {
        name: 'mpeg', value: 'mpeg'
    },
    {
        name: 'oga', value: 'oga'
    },
    {
        name: 'wav', value: 'wav'
    },
    {
        name: 'weba', value: 'weba'
    },
    {
        name: 'webm', value: 'webm'
    }
];